/* ============================================================================
   coverage-co-data.js — iShop Colombia
   Tablas de SLA, centroides de zonas y línea norte/sur de Bogotá.
   FUENTE DE VERDAD: Departamento_ciudad_colombia.xlsx (lista definitiva).
   Sin lógica: solo datos. Consumido por coverage-co.js y
   announcement-delivery-co.js.
   ============================================================================

   VOCABULARIO DE SLA (del archivo definitivo):
     Bogotá   -> mismo día antes de las 11:00 a.m. / siguiente día hábil
     2        -> 2 días hábiles fijos      (sin "o antes")
     3        -> 3 días hábiles fijos      (sin "o antes")
     2 a 3    -> n=3, rango  ("o antes")
     3 a 6    -> n=6, rango  ("o antes")
     6 a 10   -> n=10, rango ("o antes")   (municipios sueltos; no default depto)
     6 a 15   -> n=15, rango ("o antes")   (Amazonas, Guainía, Vaupés, Vichada)
     Sin cob. -> San Andrés, Providencia y Santa Catalina

   n     = días hábiles (cota ALTA del rango cuando range=true)
   range = true -> el copy dice "el {dia} o antes"

   NOTA DE GRANULARIDAD: el archivo es municipio a municipio y los
   departamentos NO son homogéneos. La barra resuelve por GPS a centroide de
   ciudad o "resto del departamento" (valor dominante del depto). Para las 18
   ciudades nombradas el valor es EXACTO; para el resto es el valor típico del
   departamento. Precisión municipio-exacta requeriría geocodificación (Fase 2).
*/
(function (w) {
  'use strict';

  w.CO_SLA = {
    /* ---- Bogotá: mismo día antes de las 11:00 a.m. ---- */
    bogota:        { n: 1, range: false, sameDay: true, label: 'Bogotá' },

    /* ---- Ciudades nombradas: 2 días hábiles FIJOS ---- */
    medellin:      { n: 2, range: false, label: 'Medellín' },
    envigado:      { n: 2, range: false, label: 'Envigado' },
    rionegro:      { n: 2, range: false, label: 'Rionegro' },
    cali:          { n: 2, range: false, label: 'Cali' },
    barranquilla:  { n: 2, range: false, label: 'Barranquilla' },
    cartagena:     { n: 2, range: false, label: 'Cartagena' },
    bucaramanga:   { n: 2, range: false, label: 'Bucaramanga' },
    chia:          { n: 2, range: false, label: 'Chía' },
    tunja:         { n: 2, range: false, label: 'Tunja' },
    ibague:        { n: 2, range: false, label: 'Ibagué' },
    pereira:       { n: 2, range: false, label: 'Pereira' },
    manizales:     { n: 2, range: false, label: 'Manizales' },
    armenia:       { n: 2, range: false, label: 'Armenia' },
    valledupar:    { n: 2, range: false, label: 'Valledupar' },
    neiva:         { n: 2, range: false, label: 'Neiva' },
    villavicencio: { n: 2, range: false, label: 'Villavicencio' },
    yopal:         { n: 2, range: false, label: 'Yopal' },
    florencia:     { n: 2, range: false, label: 'Florencia' },

    /* ---- Ciudades nombradas: 3 días hábiles FIJOS ---- */
    popayan:       { n: 3, range: false, label: 'Popayán' },
    cucuta:        { n: 3, range: false, label: 'Cúcuta' },
    pasto:         { n: 3, range: false, label: 'Pasto' },
    monteria:      { n: 3, range: false, label: 'Montería' },
    sanjoseguaviare:{ n: 3, range: false, label: 'San José del Guaviare' },

    /* ---- Ciudades nombradas: rango 3 a 6 ---- */
    maicao:        { n: 6, range: true, label: 'Maicao' },
    mocoa:         { n: 6, range: true, label: 'Mocoa' },

    /* ---- Resto de departamento: 2 a 3 (rango) ---- */
    antioquia_resto: { n: 3, range: true, label: 'Antioquia' },
    valle_resto:     { n: 3, range: true, label: 'Valle del Cauca' },
    atlantico_resto: { n: 3, range: true, label: 'Atlántico' },
    santander_resto: { n: 3, range: true, label: 'Santander' },
    bolivar_resto:   { n: 3, range: true, label: 'Bolívar' },

    /* ---- Resto de departamento: 2 fijo ---- */
    cundinamarca:  { n: 2, range: false, label: 'Cundinamarca' },
    boyaca:        { n: 2, range: false, label: 'Boyacá' },

    /* ---- Territorios lejanos: 6 a 15 ---- */
    amazonas:      { n: 15, range: true, label: 'Amazonas' },
    guainia:       { n: 15, range: true, label: 'Guainía' },
    vaupes:        { n: 15, range: true, label: 'Vaupés' },
    vichada:       { n: 15, range: true, label: 'Vichada' },

    /* ---- Default nacional: 3 a 6 (valor dominante del resto del país) ---- */
    otros:         { n: 6, range: true, label: 'tu municipio' },

    /* ---- Sin cobertura: Archipiélago de San Andrés, Providencia y
       Santa Catalina. Mensaje fijo (txtSinCobertura). ---- */
    sanandres:     { noDelivery: true, label: 'San Andrés, Providencia y Santa Catalina' }
  };

  /* CENTROIDES DE ZONAS. Resolución por proximidad: se asigna la zona del
     centroide más cercano dentro de radiusKm; si no, el deptKey si está
     dentro del anillo departamental; si no, 'otros'. */
  w.CO_ZONES = [
    { key: 'bogota',         lat: 4.6710,  lng: -74.0900, radiusKm: 22, deptKey: 'cundinamarca' },
    { key: 'chia',           lat: 4.8650,  lng: -74.0500, radiusKm: 8,  deptKey: 'cundinamarca' },
    { key: 'medellin',       lat: 6.2442,  lng: -75.5812, radiusKm: 14, deptKey: 'antioquia_resto' },
    { key: 'envigado',       lat: 6.1710,  lng: -75.5920, radiusKm: 6,  deptKey: 'antioquia_resto' },
    { key: 'rionegro',       lat: 6.1550,  lng: -75.3740, radiusKm: 12, deptKey: 'antioquia_resto' },
    { key: 'cali',           lat: 3.4516,  lng: -76.5320, radiusKm: 15, deptKey: 'valle_resto' },
    { key: 'barranquilla',   lat: 10.9685, lng: -74.7813, radiusKm: 15, deptKey: 'atlantico_resto' },
    { key: 'cartagena',      lat: 10.3910, lng: -75.4794, radiusKm: 15, deptKey: 'bolivar_resto' },
    { key: 'bucaramanga',    lat: 7.1193,  lng: -73.1227, radiusKm: 12, deptKey: 'santander_resto' },
    { key: 'tunja',          lat: 5.5446,  lng: -73.3557, radiusKm: 10, deptKey: 'boyaca' },
    { key: 'ibague',         lat: 4.4389,  lng: -75.2322, radiusKm: 12, deptKey: 'otros' },
    { key: 'pereira',        lat: 4.8087,  lng: -75.6906, radiusKm: 12, deptKey: 'otros' },
    { key: 'manizales',      lat: 5.0703,  lng: -75.5138, radiusKm: 12, deptKey: 'otros' },
    { key: 'armenia',        lat: 4.5339,  lng: -75.6811, radiusKm: 12, deptKey: 'otros' },
    { key: 'cucuta',         lat: 7.8891,  lng: -72.4967, radiusKm: 12, deptKey: 'otros' },
    { key: 'pasto',          lat: 1.2136,  lng: -77.2811, radiusKm: 12, deptKey: 'otros' },
    { key: 'valledupar',     lat: 10.4631, lng: -73.2532, radiusKm: 12, deptKey: 'otros' },
    { key: 'neiva',          lat: 2.9273,  lng: -75.2819, radiusKm: 12, deptKey: 'otros' },
    { key: 'popayan',        lat: 2.4448,  lng: -76.6147, radiusKm: 12, deptKey: 'otros' },
    { key: 'villavicencio',  lat: 4.1420,  lng: -73.6266, radiusKm: 12, deptKey: 'otros' },
    { key: 'yopal',          lat: 5.3378,  lng: -72.3959, radiusKm: 12, deptKey: 'otros' },
    { key: 'monteria',       lat: 8.7479,  lng: -75.8814, radiusKm: 12, deptKey: 'otros' },
    { key: 'maicao',         lat: 11.3778, lng: -72.2392, radiusKm: 12, deptKey: 'otros' },
    { key: 'mocoa',          lat: 1.1470,  lng: -76.6474, radiusKm: 12, deptKey: 'otros' },
    { key: 'florencia',      lat: 1.6144,  lng: -75.6062, radiusKm: 12, deptKey: 'otros' },
    { key: 'sanjoseguaviare',lat: 2.5729,  lng: -72.6459, radiusKm: 12, deptKey: 'otros' },
    /* Territorios lejanos (6 a 15). Radios amplios por su gran extensión. */
    { key: 'amazonas',       lat: -4.2150, lng: -69.9410, radiusKm: 160, deptKey: 'amazonas' },
    { key: 'guainia',        lat: 3.8653,  lng: -67.9239, radiusKm: 160, deptKey: 'guainia' },
    { key: 'vaupes',         lat: 1.2536,  lng: -70.2337, radiusKm: 160, deptKey: 'vaupes' },
    { key: 'vichada',        lat: 6.1897,  lng: -67.4859, radiusKm: 160, deptKey: 'vichada' },
    /* Archipiélago (sin cobertura). */
    { key: 'sanandres',      lat: 12.5847, lng: -81.7006, radiusKm: 30, deptKey: 'sanandres' },
    { key: 'sanandres',      lat: 13.3489, lng: -81.3746, radiusKm: 30, deptKey: 'sanandres' }
  ];
  w.CO_DEPT_RING_KM = 80;

  /* LÍNEA NORTE/SUR BOGOTÁ. El Dorado -> Monserrate, desplazada ~1 km al
     suroccidente para incluir el eje Gran Estación en el lado norte. */
  w.CO_BOGOTA_LINE = {
    a: { lat: 4.6954, lng: -74.1534 },
    b: { lat: 4.5995, lng: -74.0622 }
  };

  /* Zonas con retiro en tienda en 1h (lista definitiva: 16 ciudades + Bogotá
     norte). NOTA: Bucaramanga YA NO ofrece retiro. */
  w.CO_PICKUP_CITIES = [
    'armenia','barranquilla','bogota','cali','chia','envigado','ibague',
    'manizales','medellin','neiva','pereira','popayan','rionegro','tunja',
    'valledupar','villavicencio','yopal'
  ];
})(window);
